<div mat-dialog-content>    
    <h6>¿Estás {{usersSVC.currentUser.gender == 'male'? 'seguro': 'segura'}} que deseas eliminar el post <strong>"{{data.title}}"?</strong></h6>
</div>
<div mat-dialog-actions>
  <button mat-button color="warn" (click)="onNoClick()">Cancelar</button>
  <button mat-button [mat-dialog-close]="data.postID" cdkFocusInitial>Eliminar</button>
</div>